(function () {
  'use strict';
  if (window.__ttBlackFridayBanners) { window.__ttBlackFridayBanners.refresh(); return; }
  const states = new Map();
  const bannerSelector = '.tt-announce, .tt-midnight-bar, .ttac-announce, .ttbf-announce, .ttnf-announce';
  const rootSelector = '[data-tt-seasonal-root], [data-tt-midnight-root]';
  const contextNode = document.querySelector('script[data-tt-bf-context]');
  const pageContext = location.pathname + ' ' + (contextNode ? contextNode.dataset.ttBfContext : '');
  const campaignTitle = contextNode && contextNode.dataset.ttBfSaleLabel || 'Early Black Friday Sale';
  const generalCycleMs = 59 * 60 * 60 * 1000;
  const generalDeadlineKey = 'tt-bf-general-deadline-59h-v1';
  let generalDeadline = 0;
  function generalSeconds(now) {
    if (!generalDeadline) {
      let saved = 0;
      try { saved = Number(window.localStorage.getItem(generalDeadlineKey)); } catch (error) { /* Storage can be unavailable. */ }
      generalDeadline = Number.isFinite(saved) && saved > 0 && saved <= now + generalCycleMs ? saved : now + generalCycleMs;
    }
    if (generalDeadline <= now) {
      generalDeadline += (Math.floor((now - generalDeadline) / generalCycleMs) + 1) * generalCycleMs;
    }
    try {
      if (window.localStorage.getItem(generalDeadlineKey) !== String(generalDeadline)) window.localStorage.setItem(generalDeadlineKey, String(generalDeadline));
    } catch (error) { /* Keep the countdown running in memory. */ }
    return Math.max(0, Math.ceil((generalDeadline - now) / 1000));
  }
  function span(className, value) {
    const node = document.createElement('span'); node.className = className;
    if (value) node.textContent = value;
    return node;
  }
  function offerFor(context, original, header) {
    const astronaut = document.querySelector('[data-tt-astronaut]');
    if (astronaut && astronaut.dataset.ttOffer) return astronaut.dataset.ttOffer;
    if (header) return 'Up to 75% OFF + Free Gifts';
    if (/busy.?board|play.?board|busy-7r|montessori-4th/i.test(context)) return 'Up to 67% OFF + Free Gifts';
    if (/busy.?book|preschool-busy|back-to-school-busy/i.test(context)) return 'Up to 58% OFF + Free Gifts';
    if (/goggle|swim/i.test(context)) return 'Buy 1, Get 1 Free + Free Gifts';
    if (/galaxy.?glow|galaxy-glow/i.test(context)) return 'Up to 45% OFF + Free Gifts';
    if (/christmas.?tree|tt-xtree/i.test(context)) return 'Up to 42% OFF + Free Gifts';
    if (/projector|magic.?splash|water.?colo[ur]|colo[ur]ing/i.test(context)) {
      const buy = original.match(/buy\s*([12])\s*[,·+]?\s*get\s*1\s*free/i);
      const quantity = /b1g1|buy-1|get-1-free-b1/i.test(context) ? '1' : /b2g1|buy-2/i.test(context) ? '2' : buy ? buy[1] : '2';
      return 'Buy ' + quantity + ', Get 1 Free';
    }
    const cleaned = original.replace(/🎃|🍂|🎁/gu, '').replace(/\s+/g, ' ').trim();
    return cleaned && !/^((halloween|fall|summer|launch).*(sale|offer))$/i.test(cleaned) ? cleaned : 'Up to 75% OFF + Free Gifts';
  }
  function makeClock(includeDays) {
    const clock = span('tt-bf-clock');
    const keys = includeDays ? ['d', 'h', 'm', 's'] : ['h', 'm', 's'];
    const labels = includeDays ? ['DAYS', 'HRS', 'MIN', 'SEC'] : ['HRS', 'MIN', 'SEC'];
    labels.forEach((label, index) => {
      if (index) { const sep = span('tt-bf-separator', ':'); sep.setAttribute('aria-hidden', 'true'); clock.append(sep); }
      const unit = span('tt-bf-unit'); const digit = span('tt-bf-digit', '00');
      digit.dataset.ttBfDigit = keys[index];
      unit.append(digit, span('tt-bf-unit-label', label)); clock.append(unit);
    });
    return clock;
  }
  function decorateClock(clock, includeDays) {
    clock.classList.add('tt-bf-clock'); clock.setAttribute('role', 'timer');
    clock.setAttribute('aria-live', 'off'); clock.setAttribute('aria-label', 'Countdown');
    const selectors = [
      '[data-tt-midnight-h], [data-tt-cd-h], [data-cd="hh"], [data-h], [data-tt-bf-digit="h"]',
      '[data-tt-midnight-m], [data-tt-cd-m], [data-cd="mm"], [data-m], [data-tt-bf-digit="m"]',
      '[data-tt-midnight-s], [data-tt-cd-s], [data-cd="ss"], [data-s], [data-tt-bf-digit="s"]'
    ];
    if (includeDays) selectors.unshift('[data-tt-bf-digit="d"]');
    let digits = selectors.map(selector => clock.querySelector(selector));
    if (digits.some(digit => !digit)) {
      const replacement = makeClock(includeDays); clock.append(...Array.from(replacement.childNodes));
      digits = (includeDays ? ['d', 'h', 'm', 's'] : ['h', 'm', 's']).map(key => clock.querySelector('[data-tt-bf-digit="' + key + '"]'));
    }
    digits.forEach(digit => { digit.classList.add('tt-bf-digit'); digit.parentElement.classList.add('tt-bf-unit'); });
    clock.querySelectorAll('.tt-midnight-sep, .tt-announce__timer-sep, i').forEach(node => { node.classList.add('tt-bf-separator'); node.setAttribute('aria-hidden', 'true'); });
    clock.querySelectorAll('small, .tt-announce__timer-label').forEach(node => node.classList.add('tt-bf-unit-label'));
    return digits;
  }
  function decoratePromos(root) {
    root.querySelectorAll('.tt-promo-bts__inner').forEach(card => {
      if (card.closest(rootSelector) !== root) return;
      card.classList.add('tt-bf-promo');
      const heading = card.querySelector('.tt-promo-bts__title');
      if (heading) { heading.textContent = campaignTitle; heading.setAttribute('data-tt-seasonal-name', ''); }
    });
  }
  const stickyBars = new Set();
  const stickySelector = '.tt-sticky[data-tt-sticky], .tt-sticky-cta, .sg-sticky-cta, .tt-aff__sticky, .tt-tg__sticky, .ttac-sticky, .ttpdp-sticky, .ttlc-sticky, .ttso-sticky-bottom';
  function measureStickies() {
    let height = 0;
    stickyBars.forEach(bar => {
      if (!bar.isConnected) { stickyBars.delete(bar); return; }
      height = Math.max(height, bar.getBoundingClientRect().height);
    });
    document.documentElement.style.setProperty('--tt-bf-sticky-height', Math.ceil(height) + 'px');
  }
  const stickyResize = 'ResizeObserver' in window ? new ResizeObserver(measureStickies) : null;
  function decorateStickies() {
    document.querySelectorAll(stickySelector).forEach(bar => {
      if (stickyBars.has(bar) || bar.closest('.alchemy__element, [data-replo]')) return;
      if (!bar.closest(rootSelector + ', [data-tt-affirmations], [data-tt-trace-grow]')) return;
      const info = bar.querySelector('.tt-sticky__text, .tt-sticky-cta__text, .sg-sticky-cta__text, .ttac-sticky__info, .ttpdp-sticky__info, .ttlc-sticky__info, .ttso-sticky-info') || bar.querySelector(':scope > div');
      if (!info) return;
      bar.querySelectorAll('[data-tt-product-sale-update]').forEach(note => note.remove());
      bar.dataset.ttBfSticky = 'true';
      info.dataset.ttBfStickyCopy = 'true';
      info.prepend(span('tt-bf-sticky-label', campaignTitle));
      const offer = bar.querySelector('.tt-sticky__offer, .tt-sticky-cta__offer, .sg-sticky-cta__offer');
      if (offer) {
        const root = bar.closest(rootSelector);
        offer.textContent = offerFor(pageContext + ' ' + (root ? root.id + ' ' + root.className : ''), offer.textContent, false);
        offer.removeAttribute('data-tt-seasonal-alias');
        offer.removeAttribute('data-tt-seasonal-accent');
      }
      stickyBars.add(bar);
      if (stickyResize) stickyResize.observe(bar);
    });
    measureStickies();
  }

  function initialise(banner) {
    if (states.has(banner) || banner.closest('.is-lander-hidden') || !banner.closest(rootSelector)) return;
    const root = banner.closest(rootSelector);
    const header = root.classList.contains('tt-header-wrap');
    const originalBenefit = banner.querySelector('.tt-midnight-benefit, .tt-announce__benefit, .tt-announce__line, .tt-announce__offer');
    const original = (originalBenefit || banner).textContent;
    const context = pageContext + ' ' + root.id + ' ' + root.className + ' ' + (root.dataset.build || '');
    const offer = offerFor(context, original, header);
    const messages = [offer, 'Free $15 gift card with every order', '1 order refunded every day in November 🎁'];
    root.dataset.ttBlackFridayRoot = 'true';
    decoratePromos(root);
    banner.classList.add('tt-bf-banner');
    banner.dataset.ttBfOriginalOffer = original.replace(/\s+/g, ' ').trim();
    let copy = banner.querySelector('.tt-midnight-copy, .tt-announce__copy');
    let heading; let benefit; let clock;
    if (header || !copy) {
      const inner = document.createElement(header && banner.tagName === 'DIV' ? 'a' : 'span');
      inner.className = 'tt-bf-inner';
      if (inner.tagName === 'A') inner.href = '/collections/bestsellers';
      copy = span('tt-bf-copy'); heading = span('tt-bf-heading'); benefit = span('tt-bf-benefit'); clock = makeClock(header);
      copy.append(heading, benefit); inner.append(copy, clock); banner.replaceChildren(inner);
    } else {
      heading = copy.querySelector('.tt-midnight-heading, .tt-announce__heading, .tt-announce__name');
      benefit = copy.querySelector('.tt-midnight-benefit, .tt-announce__benefit, .tt-announce__line');
      if (!heading) { heading = span('tt-bf-heading'); copy.prepend(heading); }
      if (!benefit || benefit === heading) { benefit = span('tt-bf-benefit'); copy.append(benefit); }
      clock = banner.querySelector('.tt-midnight-timer, .tt-announce__timer, [data-tt-countdown]');
      if (!clock) { clock = makeClock(); banner.append(clock); }
    }
    copy.classList.add('tt-bf-copy'); heading.classList.add('tt-bf-heading'); benefit.classList.add('tt-bf-benefit');
    heading.textContent = campaignTitle; benefit.textContent = messages[0];
    benefit.setAttribute('aria-hidden', 'true');
    const accessible = span('tt-bf-sr', messages.join('. ')); copy.append(accessible);
    const digits = decorateClock(clock, header);
    const state = { messages, benefit, digits, clock, general: header, index: 0, next: Date.now() + 5000, paused: false, resize: null };
    banner.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') state.paused = true; });
    banner.addEventListener('pointerleave', () => { state.paused = false; });
    banner.addEventListener('focusin', () => { state.paused = true; });
    banner.addEventListener('focusout', event => { if (!banner.contains(event.relatedTarget)) state.paused = false; });
    if (header) {
      root.dataset.ttBfHeader = 'true';
      const measure = () => document.documentElement.style.setProperty('--tt-bf-header-height', root.getBoundingClientRect().height + 'px');
      if ('ResizeObserver' in window) { state.resize = new ResizeObserver(measure); state.resize.observe(root); }
      measure();
    }
    states.set(banner, state);
  }
  function refresh() { document.querySelectorAll(bannerSelector).forEach(initialise); decorateStickies(); tick(); }
  function tick() {
    if (document.hidden) return;
    const nowMs = Date.now();
    const now = new Date(nowMs); const midnight = new Date(now); midnight.setHours(24, 0, 0, 0);
    const seconds = Math.max(0, Math.floor((midnight - now) / 1000));
    const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0'));
    for (const [banner, state] of states) {
      if (!banner.isConnected) { if (state.resize) state.resize.disconnect(); states.delete(banner); continue; }
      let timerValues = values;
      if (state.general) {
        const remaining = generalSeconds(nowMs);
        timerValues = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60].map(value => String(value).padStart(2, '0'));
        if (state.clock.dataset.ttBfDeadline !== String(generalDeadline)) {
          state.clock.dataset.ttBfDeadline = String(generalDeadline);
          const localDeadline = new Date(generalDeadline).toLocaleString();
          state.clock.title = localDeadline;
          state.clock.setAttribute('aria-label', 'Countdown to ' + localDeadline);
        }
      }
      state.digits.forEach((digit, index) => { if (digit.textContent !== timerValues[index]) digit.textContent = timerValues[index]; });
      if (!state.paused && Date.now() >= state.next) { state.index = (state.index + 1) % state.messages.length; state.benefit.textContent = state.messages[state.index]; state.next = Date.now() + 5000; }
    }
  }
  window.__ttBlackFridayBanners = { refresh };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('resize', measureStickies);
  window.setInterval(tick, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
})();

